import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './thong-tin-dia-phuong.reducer';

export const ThongTinDiaPhuongDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const thongTinDiaPhuongEntity = useAppSelector(state => state.thongTinDiaPhuong.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="thongTinDiaPhuongDetailsHeading">
          <Translate contentKey="xtdtApp.thongTinDiaPhuong.detail.title">ThongTinDiaPhuong</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{thongTinDiaPhuongEntity.id}</dd>
          <dt>
            <span id="moTa">
              <Translate contentKey="xtdtApp.thongTinDiaPhuong.moTa">Mo Ta</Translate>
            </span>
          </dt>
          <dd>{thongTinDiaPhuongEntity.moTa}</dd>
          <dt>
            <span id="dienTich">
              <Translate contentKey="xtdtApp.thongTinDiaPhuong.dienTich">Dien Tich</Translate>
            </span>
          </dt>
          <dd>{thongTinDiaPhuongEntity.dienTich}</dd>
          <dt>
            <span id="danSo">
              <Translate contentKey="xtdtApp.thongTinDiaPhuong.danSo">Dan So</Translate>
            </span>
          </dt>
          <dd>{thongTinDiaPhuongEntity.danSo}</dd>
          <dt>
            <span id="soLaoDong">
              <Translate contentKey="xtdtApp.thongTinDiaPhuong.soLaoDong">So Lao Dong</Translate>
            </span>
          </dt>
          <dd>{thongTinDiaPhuongEntity.soLaoDong}</dd>
          <dt>
            <span id="gRDP">
              <Translate contentKey="xtdtApp.thongTinDiaPhuong.gRDP">G RDP</Translate>
            </span>
          </dt>
          <dd>{thongTinDiaPhuongEntity.gRDP}</dd>
          <dt>
            <span id="gRDPNguoi">
              <Translate contentKey="xtdtApp.thongTinDiaPhuong.gRDPNguoi">G RDP Nguoi</Translate>
            </span>
          </dt>
          <dd>{thongTinDiaPhuongEntity.gRDPNguoi}</dd>
        </dl>
        <Button tag={Link} to="/thong-tin-dia-phuong" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/thong-tin-dia-phuong/${thongTinDiaPhuongEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ThongTinDiaPhuongDetail;
